import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fes-requirements',
  templateUrl: './requirements.component.html',
  styleUrls: ['./requirements.component.scss']
})
export class RequirementsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
